/* global BigInt */
import { PARAM_KEY } from '../constants/params';
import { v4 as uuidv4 } from 'uuid';
import { serviceAxiosInstance } from '../config/api.service.config';

// Helper to convert UUID to 32-char hex string for GCP Trace ID
export function generateTraceId() {
  return uuidv4().replace(/-/g, '');
}

export function getOrSetTraceId() {
  let traceId = localStorage.getItem('GCP_TRACE_ID');
  if (!traceId) {
    traceId = generateTraceId();
    localStorage.setItem('GCP_TRACE_ID', traceId);
  }
  return traceId;
}

// Generate a secure random 64-bit integer as a decimal string for Span ID
export function generateSpanId() {
  const array = new Uint32Array(2);
  window.crypto.getRandomValues(array);
  // Combine two 32-bit integers into a 64-bit BigInt and convert to string
  const val = BigInt(array[0]) * BigInt(4294967296) + BigInt(array[1]);
  return val.toString();
}

export function setUserInfoToSession(sessionObj) {
  const currTime = new Date().getTime();
  localStorage.setItem(PARAM_KEY.session.KEY1, JSON.stringify(sessionObj));
  const expirationTime = currTime + 4 * 60 * 60 * 1000; // 4 hrs
  localStorage.setItem(PARAM_KEY.session.KEY_EXPIRE, expirationTime.toString());
}

export function getUserInfoFromSession() {
  const currTime = new Date().getTime();
  const tokenExpiration = localStorage.getItem(PARAM_KEY.session.KEY_EXPIRE);

  if (currTime > tokenExpiration) {
    localStorage.removeItem(PARAM_KEY.session.KEY1);
    localStorage.removeItem(PARAM_KEY.session.KEY_EXPIRE);
    return null;
  } else {
    return JSON.parse(localStorage.getItem(PARAM_KEY.session.KEY1));
  }
}

export function getPPropertyInfoFromSession() {
  const currTime = new Date().getTime();
  const tokenExpiration = localStorage.getItem(PARAM_KEY.session.KEY_EXPIRE);

  if (currTime > tokenExpiration) {
    localStorage.removeItem(PARAM_KEY.session.KEY4);
    localStorage.removeItem(PARAM_KEY.session.KEY_EXPIRE);
    return null;
  } else {
    return JSON.parse(localStorage.getItem(PARAM_KEY.session.KEY4));
  }
}

export function updateUserInfoContryCd(countryCd) {
  const uInfo = getUserInfoFromSession();
  uInfo.countryCd = countryCd;
  setUserInfoToSession(uInfo);
}
